export default "__VITE_ASSET__CmJuQfuk__"